/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    USER_EMAIL_NOT_EXIST: {
        code: 'USER_EMAIL_NOT_EXIST',
        description: 'User with requested email does not exist.',
    },
    USER_PASSWORD_DOES_NOT_MATCH: {
        code: 'USER_PASSWORD_DOES_NOT_MATCH',
        description: 'User with requested email does not exist.',
    },
    ORGANISATION_DOMAIN_DUPLICITY: {
        code: 'ORGANISATION_DOMAIN_DUPLICITY',
        description: 'Office with requested domain name already exists.',
    },
    USER_EMAIL_DUPLICITY: {
        code: 'USER_EMAIL_DUPLICITY',
        description: 'User with requested email already exists.',
    },
    LECTURE_START_IN_PAST: {
        code: 'LECTURE_START_IN_PAST',
        description: 'Lecture start is in the past.',
    },
    LECTURE_OUTSIDE_OPENING_HOURS: {
        code: 'LECTURE_OUTSIDE_OPENING_HOURS',
        description: 'Lecture cannot be created outside opening hours of office.',
    },
    CURRENCY_NOT_ACCEPTED: {
        code: 'CURRENCY_NOT_ACCEPTED',
        description: 'This currency is not accepted by office.',
    },
    ONE_OF_ONLINE_OR_PHYSICAL_LECTURE_REQUIRED: {
        code: 'ONE_OF_ONLINE_OR_PHYSICAL_LECTURE_REQUIRED',
        description: 'One of online or physical lecture property has to be preset.',
    },
};
